function getMadridRemainingSeconds() {
  try {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date());
    var get = function (t) {
      var p = parts.find(function (x) { return x.type === t; });
      return p ? parseInt(p.value, 10) : 0;
    };
    var h = get('hour') % 24;
    var m = get('minute');
    var s = get('second');
    var remaining = 86400 - (h * 3600 + m * 60 + s);
    return remaining <= 0 ? 86400 : remaining;
  } catch (e) {
    var now = new Date();
    var next = new Date(now);
    next.setHours(24, 0, 0, 0);
    return Math.max(1, Math.floor((next - now) / 1000));
  }
}

function applyDeliveryDates(root) {
  if (!root) return;
  var el = root.querySelector('.atc-modal-delivery-date');
  if (!el) return;

  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  // Determine the shipping start date using Madrid time.
  // Cutoff: orders placed Mon–Thu (any time) or Fri before 12:00 Madrid ship today.
  // Otherwise (Fri ≥12:00, Sat, Sun) shipping starts next Monday.
  function getShippingStartDate() {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Madrid',
        weekday: 'short',
        hour: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      return new Date();
    }
    var weekdayMap = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
    var weekdayPart = parts.find(function (p) { return p.type === 'weekday'; });
    var hourPart = parts.find(function (p) { return p.type === 'hour'; });
    var day = weekdayPart ? weekdayMap[weekdayPart.value] : new Date().getDay();
    var hour = hourPart ? parseInt(hourPart.value, 10) % 24 : new Date().getHours();

    var start = new Date();
    var pastCutoff = (day === 5 && hour >= 12) || day === 6 || day === 0;
    if (pastCutoff) {
      // Advance to next Monday in local time. addBusinessDays skips Sat/Sun
      // so adding 1 business day from Fri/Sat/Sun lands on the following Monday.
      start = addBusinessDays(start, 1);
    }
    return start;
  }

  var country = el.getAttribute('data-country');
  var shippingStart = getShippingStartDate();
  var isES = country === 'ES';
  var minDays = isES ? 1 : 3;
  var maxDays = isES ? 2 : 4;

  var minDate = addBusinessDays(shippingStart, minDays);
  var maxDate = addBusinessDays(shippingStart, maxDays);

  var lang = document.documentElement.lang || 'es';
  var opts = { day: 'numeric', month: 'long' };
  var minStr = minDate.toLocaleDateString(lang, opts);
  var maxStr = maxDate.toLocaleDateString(lang, opts);

  var dateRange = '<strong style="color:#000">' + minStr + ' - ' + maxStr + '</strong>';
  var html = 'Entrega entre el ' + dateRange + ' (Excepto festivos)';
  el.innerHTML = html;

  var popupEl = root.querySelector('.atc-modal-delivery-date-popup');
  if (popupEl) {
    popupEl.innerHTML = html;
  }
}

function renderInfiniteCountdown(targets) {
  var rem = getMadridRemainingSeconds();
  var h = Math.floor(rem / 3600);
  var m = Math.floor((rem % 3600) / 60);
  var s = rem % 60;
  if (targets.daysEl) targets.daysEl.textContent = '00';
  if (targets.hoursEl) targets.hoursEl.textContent = String(h).padStart(2, '0');
  if (targets.minutesEl) targets.minutesEl.textContent = String(m).padStart(2, '0');
  if (targets.secondsEl) targets.secondsEl.textContent = String(s).padStart(2, '0');
  if (targets.singleEl) {
    targets.singleEl.textContent =
      String(h).padStart(2, '0') + ' : ' +
      String(m).padStart(2, '0') + ' : ' +
      String(s).padStart(2, '0');
  }
}

if (!customElements.get('atc-bottom-modal')) {
  customElements.define(
    'atc-bottom-modal',
    class extends HTMLElement {
      connectedCallback() {
        // Move to document.body to escape any parent transform/contain
        // that would break position:fixed
        if (this.parentNode !== document.body) {
          document.body.appendChild(this);
        }

        this.modal = this.querySelector('.atc-modal');
        this.sectionId = this.dataset.sectionId;

        // Close when clicking the backdrop (the custom element itself)
        this.addEventListener('click', (e) => {
          if (e.target === this) this.close();
        });

        // Close on X button click
        this.querySelectorAll('.atc-modal__close').forEach((btn) => {
          btn.addEventListener('click', () => this.close());
        });

        // ESC key
        this._onKeyUp = (e) => {
          if (e.code === 'Escape' && this.hasAttribute('open')) {
            this.close();
          }
        };
        document.addEventListener('keyup', this._onKeyUp);

        // Listen for variant changes inside the modal
        this.listenForVariantChanges();

        // Intercept form submit to validate within modal scope
        this.setupFormValidation();

        // Delivery info popup toggle
        this.initDeliveryPopups();

        // Close modal when notify button is clicked
        this.setupNotifyClose();

        // Countdown timer
        this.initCountdown();

        // Move store inventory widget into modal permanently
        this.moveStoreInventoryIn();

        // Auto-close modal when cart is updated (after successful add-to-cart)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._cartUpdateUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            if (this.hasAttribute('open')) this.close();
          });
        }
      }

      disconnectedCallback() {
        if (this._cartUpdateUnsubscribe) {
          this._cartUpdateUnsubscribe();
        }
        if (this._onKeyUp) {
          document.removeEventListener('keyup', this._onKeyUp);
        }
        if (this._countdownInterval) {
          clearInterval(this._countdownInterval);
        }
      }

      open(opener) {
        this.openedBy = opener;
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');

        if (typeof trapFocus === 'function') {
          trapFocus(this.modal, this.querySelector('.atc-modal__close'));
        }

        // Initialize Shopify payment buttons inside modal
        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        // Calculate delivery dates for modal
        this.calculateDeliveryDates();
      }

      close() {
        if (this._closing) return;
        this._closing = true;

        // Add closing class to trigger slide-down + fade-out animations
        this.classList.add('closing');
        this.removeAttribute('open');

        // Wait for animation to finish, then clean up
        setTimeout(() => {
          this.classList.remove('closing');
          this._closing = false;
          document.body.classList.remove('overflow-hidden');

          if (typeof removeTrapFocus === 'function') {
            removeTrapFocus(this.openedBy);
          }
        }, 300);
      }

      listenForVariantChanges() {
        this.addEventListener('change', (e) => {
          const input = e.target;
          if (!input.classList.contains('variant-input')) return;

          const variantId = input.dataset.variantId;
          const inventory = parseInt(input.dataset.inventory, 10) || 0;
          const available = input.dataset.variantAvailable === 'true';
          const continueSelling = input.dataset.continueSelling === 'true';
          const isOutOfStock = input.classList.contains('disabled');
          const isFastShipping = input.hasAttribute('variant-fast-ship-input');

          // Update the hidden variant ID input so the correct variant is added to cart
          const hiddenInput = this.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = variantId;

          this.updateImage(variantId);
          this.updatePrice(variantId);
          this.updateDeliveryInfo(isFastShipping, isOutOfStock);
          this.updateStockInfo(inventory, isOutOfStock);
          this.toggleNotifyButton(!available && !continueSelling && inventory <= 0);
        });
      }

      updateImage(variantId) {
        const imageEl = this.querySelector('.atc-modal__product-image');
        if (!imageEl) return;

        const variantRadios = this.querySelector('variant-radios, variant-selects');
        if (!variantRadios) return;

        const jsonScript = variantRadios.querySelector('script[type="application/json"]');
        if (!jsonScript) return;

        try {
          const variants = JSON.parse(jsonScript.textContent);
          const variant = variants.find((v) => String(v.id) === String(variantId));
          if (variant && variant.featured_image) {
            imageEl.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_160x$1');
            imageEl.alt = variant.featured_image.alt || '';
          }
        } catch (e) {
          // Silently fail
        }
      }

      updatePrice(variantId) {
        const priceContainer = this.querySelector('.atc-modal__price');
        if (!priceContainer) return;

        const variantRadios = this.querySelector('variant-radios, variant-selects');
        if (!variantRadios) return;

        const jsonScript = variantRadios.querySelector('script[type="application/json"]');
        if (!jsonScript) return;

        try {
          const variants = JSON.parse(jsonScript.textContent);
          const variant = variants.find((v) => String(v.id) === String(variantId));
          if (!variant) return;

          const formatMoney = (cents) => {
            if (window.Shopify && window.Shopify.formatMoney) {
              return window.Shopify.formatMoney(cents);
            }
            return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
          };

          // Mirror the Liquid pricing in product-atc-modal.liquid: stacked promo
          // discount (data-extra-percentage), strike fallback, and floor-rounded
          // base percentage (Liquid integer division), so the row survives the
          // variant-change rebuild without diverging from the PDP.
          const extraPct = parseFloat(priceContainer.dataset.extraPercentage) || 0;
          let finalPrice = variant.price;
          let useExtra = false;
          if (extraPct > 0) {
            const extraFinal = Math.round(variant.price * (1 - extraPct / 100));
            if (extraFinal > 0 && extraFinal < variant.price) {
              useExtra = true;
              finalPrice = extraFinal;
            }
          }

          let strikePrice = variant.compare_at_price;
          if (useExtra && (!strikePrice || strikePrice <= finalPrice)) {
            strikePrice = variant.price;
          }

          let basePct = 0;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            basePct = Math.floor(
              ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
            );
          }

          let html = '';
          if (strikePrice && strikePrice > finalPrice) {
            html += '<span class="atc-modal__price-compare">' + formatMoney(strikePrice) + '</span>';
            html += '<span class="atc-modal__price-final">' + formatMoney(finalPrice) + '</span>';
            let badge = '';
            if (basePct > 0) badge += '-' + basePct + '%';
            if (useExtra) badge += (basePct > 0 ? ' + ' : '-') + extraPct + '%';
            if (badge) html += '<span class="atc-modal__price-badge">' + badge + '</span>';
          } else {
            html += '<span class="atc-modal__price-final">' + formatMoney(finalPrice) + '</span>';
          }

          priceContainer.innerHTML = html;
        } catch (e) {
          // Silently fail
        }
      }

      updateDeliveryInfo(isFastShipping, isOutOfStock) {
        var deliveryInfo = this.querySelector('.atc-modal__delivery .product-info-delivery');
        if (!deliveryInfo) return;

        var fastEl = this.querySelector('.product-info-delivery__fast');
        var normalEl = this.querySelector('.product-info-delivery__normal');

        if (isOutOfStock) {
          // Out of stock: hide entire delivery info
          deliveryInfo.style.display = 'none';
          return;
        }

        // Show delivery info
        deliveryInfo.style.display = '';
        deliveryInfo.classList.toggle('fast-shipping', isFastShipping);
        deliveryInfo.classList.toggle('normal-shipping', !isFastShipping);

        if (isFastShipping) {
          if (fastEl) {
            fastEl.style.display = 'flex';
            fastEl.style.alignItems = 'center';
            fastEl.style.flexDirection = 'row';
            fastEl.style.justifyContent = 'center';
            fastEl.style.width = '100%';
          }
          if (normalEl) normalEl.style.display = 'none';
        } else {
          if (normalEl) {
            normalEl.style.display = 'flex';
            normalEl.style.alignItems = 'center';
            normalEl.style.flexDirection = 'row';
            normalEl.style.justifyContent = 'center';
            normalEl.style.width = '100%';
          }
          if (fastEl) fastEl.style.display = 'none';
        }
      }

      updateStockInfo(inventory, isOutOfStock) {
        var stockInfo = this.querySelector('.atc-modal__stock-info');
        if (!stockInfo) return;

        var stockText = stockInfo.querySelector('[data-stock-text]');
        if (!stockText) return;

        if (isOutOfStock || inventory <= 0) {
          stockInfo.classList.add('hidden');
          return;
        }

        var translations = window.theme?.translations || {};
        if (inventory === 1) {
          stockText.textContent = translations.stock_info_last_unit || 'Last unit';
          stockInfo.classList.remove('hidden');
        } else if (inventory === 2) { // 2026-09: 3+ → nothing
          stockText.textContent = translations.stock_info_low || 'Low stock';
          stockInfo.classList.remove('hidden');
        } else {
          stockInfo.classList.add('hidden');
        }
      }

      setupFormValidation() {
        var form = this.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        // Capture submit early to prevent product-form.js from scrolling the main page
        form.addEventListener('submit', function (e) {
          var variantInputs = this.closest('atc-bottom-modal').querySelectorAll('.product-variant-size-container .variant-input');
          if (variantInputs.length > 0) {
            var anyChecked = Array.from(variantInputs).some(function (input) { return input.checked; });
            var availableCount = Array.from(variantInputs).filter(function (input) { return !input.classList.contains('disabled'); }).length;

            if (availableCount > 1 && !anyChecked) {
              e.preventDefault();
              e.stopImmediatePropagation();
              // Highlight variant container inside modal only — no scroll
              var container = this.closest('atc-bottom-modal').querySelector('.product-variant-size-container');
              if (container) container.classList.add('select-size');
              return false;
            }
          }
        }, true); // useCapture to run before product-form.js handler
      }

      toggleNotifyButton(showNotify) {
        var submitBtn = this.querySelector('[id^="ProductSubmitButton-modal-"]');
        var notifyBtn = this.querySelector('[id^="ProductNotifyButton-modal-"]');

        if (showNotify) {
          if (submitBtn) submitBtn.classList.add('hidden');
          if (notifyBtn) notifyBtn.classList.remove('hidden');
        } else {
          if (submitBtn) submitBtn.classList.remove('hidden');
          if (notifyBtn) notifyBtn.classList.add('hidden');
        }
      }

      setupNotifyClose() {
        var notifyBtn = this.querySelector('[id^="ProductNotifyButton-modal-"]');
        if (notifyBtn) {
          notifyBtn.addEventListener('click', () => this.close());
        }
      }

      calculateDeliveryDates() {
        applyDeliveryDates(this);
      }

      moveStoreInventoryIn() {
        // Only move inventory widget when the modal trigger button exists
        if (!document.querySelector('.atc-modal__trigger')) return;

        var slot = this.querySelector('[data-store-inventory-slot]');
        if (!slot) return;

        var toggleBtn = slot.querySelector('[data-store-toggle]');
        var detailsWrapper = document.createElement('div');
        detailsWrapper.className = 'atc-modal__store-details';
        detailsWrapper.hidden = true;
        slot.appendChild(detailsWrapper);

        // Our own toggle logic — completely independent of the app's JS
        if (toggleBtn) {
          toggleBtn.addEventListener('click', function () {
            var expanded = detailsWrapper.hidden;
            detailsWrapper.hidden = !expanded;
            toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            // Toggle is-open on the inventory list so CSS display rules apply
            var list = detailsWrapper.querySelector('.iia-details-container');
            if (list) list.classList.toggle('is-open', expanded);
          });
        }

        function doMove() {
          var widget = document.querySelector('#inventory-info-app');
          if (!widget) return false;

          // Hide the entire outer app block container
          var appBlock = widget.closest('.shopify-app-block');
          if (appBlock) appBlock.style.display = 'none';

          // Take just the inventory list from the app, ignore the app's toggle
          var list = widget.querySelector('.iia-details-container');
          if (list) {
            detailsWrapper.appendChild(list);
          }

          return true;
        }

        // Try immediately; if the app hasn't loaded yet, wait for it
        if (!doMove()) {
          var observer = new MutationObserver(function () {
            if (doMove()) observer.disconnect();
          });
          observer.observe(document.body, { childList: true, subtree: true });
          setTimeout(function () { observer.disconnect(); }, 10000);
        }
      }

      initCountdown() {
        var countdownEl = this.querySelector('.atc-modal__countdown');
        if (!countdownEl) return;

        var isInfinite = countdownEl.dataset.infiniteLoop === 'true';
        var targetDateStr = countdownEl.dataset.countdownDate;
        if (!isInfinite && !targetDateStr) return;

        var targetDate = targetDateStr ? new Date(targetDateStr).getTime() : 0;
        var targets = {
          daysEl: countdownEl.querySelector('[data-countdown-days]'),
          hoursEl: countdownEl.querySelector('[data-countdown-hours]'),
          minutesEl: countdownEl.querySelector('[data-countdown-minutes]'),
          secondsEl: countdownEl.querySelector('[data-countdown-seconds]'),
        };

        var self = this;

        function update() {
          if (isInfinite) {
            renderInfiniteCountdown(targets);
            return;
          }

          var now = new Date().getTime();
          var distance = targetDate - now;

          if (distance <= 0) {
            countdownEl.classList.add('hidden');
            if (self._countdownInterval) clearInterval(self._countdownInterval);
            return;
          }

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          targets.daysEl.textContent = String(days).padStart(2, '0');
          targets.hoursEl.textContent = String(hours).padStart(2, '0');
          targets.minutesEl.textContent = String(minutes).padStart(2, '0');
          targets.secondsEl.textContent = String(seconds).padStart(2, '0');
        }

        update();
        this._countdownInterval = setInterval(update, 1000);
      }

      initDeliveryPopups() {
        this.addEventListener('click', (e) => {
          var infoIcon = e.target.closest('.product-info-delivery__shipping-time .svg-info, .product-info-delivery__shipping-time svg');
          if (infoIcon) {
            var content = infoIcon.closest('.product-info-delivery__content');
            if (content) {
              var popup = content.querySelector('.product-info-delivery__popup');
              if (popup) popup.classList.toggle('hidden');
            }
            return;
          }

          var closePopup = e.target.closest('.close-popup');
          if (closePopup) {
            var popup = closePopup.closest('.product-info-delivery__popup');
            if (popup) popup.classList.add('hidden');
          }
        });
      }
    }
  );
}

// Trigger button handler
document.addEventListener('DOMContentLoaded', function () {
  // Inline countdown (rendered next to the Select Size trigger, outside the modal)
  document.querySelectorAll('.atc-modal__countdown--inline').forEach(function (el) {
    var isInfinite = el.dataset.infiniteLoop === 'true';
    var targetDateStr = el.dataset.countdownDate;
    if (!isInfinite && !targetDateStr) return;
    var targetDate = targetDateStr ? new Date(targetDateStr).getTime() : 0;
    var targets = {
      daysEl: el.querySelector('[data-countdown-days]'),
      hoursEl: el.querySelector('[data-countdown-hours]'),
      minutesEl: el.querySelector('[data-countdown-minutes]'),
      secondsEl: el.querySelector('[data-countdown-seconds]'),
    };

    function updateInlineCountdown() {
      if (isInfinite) {
        renderInfiniteCountdown(targets);
        return;
      }
      var distance = targetDate - new Date().getTime();
      if (distance <= 0) {
        el.classList.add('hidden');
        if (intervalId) clearInterval(intervalId);
        return;
      }
      var d = Math.floor(distance / (1000 * 60 * 60 * 24));
      var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((distance % (1000 * 60)) / 1000);
      if (targets.daysEl) targets.daysEl.textContent = String(d).padStart(2, '0');
      if (targets.hoursEl) targets.hoursEl.textContent = String(h).padStart(2, '0');
      if (targets.minutesEl) targets.minutesEl.textContent = String(m).padStart(2, '0');
      if (targets.secondsEl) targets.secondsEl.textContent = String(s).padStart(2, '0');
    }
    updateInlineCountdown();
    var intervalId = setInterval(updateInlineCountdown, 1000);
  });

  // Landing from a size chip on a collection card (snippets/card-product.liquid
  // builds /products/handle?variant=ID&pick=1): select that size in the modal's
  // picker and open the modal, so "Añadir al carrito" is one tap away. Only
  // with pick=1 — plain ?variant= links (Google Shopping, emails, reloads)
  // must not pop the modal. pick=1 is removed from the URL afterwards.
  // With notify=1 (sold-out size, "Avísame") back-in-stock.js opens its modal.
  (function preselectFromUrl() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var variantId = params.get('variant') || '';
    if (!/^\d+$/.test(variantId) || params.get('pick') !== '1') return;
    params.delete('pick');
    try {
      var qs = params.toString();
      history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) {}

    // PDP 2026 mobile shows the sizes on the page (assets/pdp-inline-sizes.js):
    // select the size there and bring the grid into view, no sheet
    var pageInput = document.querySelector(
      '.pdp-v2 .product__info-container .variant-input[data-variant-id="' + variantId + '"]'
    );
    if (pageInput && pageInput.offsetParent !== null) {
      var runPage = function () {
        if (!pageInput.checked && !pageInput.classList.contains('disabled')) pageInput.click();
        var grid = pageInput.closest('variant-radios, variant-selects') || pageInput;
        grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      if (document.readyState === 'complete') {
        runPage();
      } else {
        window.addEventListener('load', runPage, { once: true });
      }
      return;
    }

    var modal = document.querySelector('atc-bottom-modal');
    if (!modal || typeof modal.open !== 'function') return;
    var input = modal.querySelector('.variant-input[data-variant-id="' + variantId + '"]');
    if (!input || input.classList.contains('disabled')) return;

    var run = function () {
      if (!input.checked) input.click(); // fires change → price, image, hidden id
      modal.open(document.querySelector('[data-open-atc-modal]') || modal);
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  })();

  document.querySelectorAll('[data-open-atc-modal]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sectionId = btn.closest('[data-section-id]')
        ? btn.closest('[data-section-id]').dataset.sectionId
        : null;
      var modal = document.querySelector('atc-bottom-modal' + (sectionId ? '[data-section-id="' + sectionId + '"]' : ''));
      if (!modal) return;

      // Single-variant products: skip the modal and add to cart directly
      // by submitting the form already wired up inside the modal.
      if (btn.hasAttribute('data-single-variant')) {
        var form = modal.querySelector('product-form form');
        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
          return;
        }
      }

      modal.open(btn);
    });
  });

  // Floating sticky bar: visible only when the inline ATC trigger button is OUT of viewport.
  // The two must never appear together on mobile.
  var floatingBar = document.querySelector('.atc-floating-bar');
  if (floatingBar) {
    document.body.appendChild(floatingBar);

    var inlineTrigger = document.querySelector('.atc-modal__trigger');
    var triggerVisible = true;
    // 'above' = trigger is below the viewport (user hasn't scrolled to it yet) → compact bar
    // 'below' = trigger is above the viewport (user has scrolled past it) → full bar
    var triggerPosition = 'above';

    function applyVisibility() {
      var modalOpen = !!document.querySelector('atc-bottom-modal[open]');
      var shouldShow = !triggerVisible && !modalOpen;
      floatingBar.classList.toggle('is-visible', shouldShow);
      floatingBar.classList.toggle('atc-floating-bar--compact', shouldShow && triggerPosition === 'above');
      floatingBar.setAttribute('aria-hidden', String(!shouldShow));
    }

    if (inlineTrigger && 'IntersectionObserver' in window) {
      var triggerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          triggerVisible = entry.isIntersecting;
          triggerPosition = entry.boundingClientRect.top >= window.innerHeight ? 'above' : 'below';
          applyVisibility();
        });
      }, { threshold: 0 });
      triggerObserver.observe(inlineTrigger);
    } else {
      // No inline trigger on this page (e.g. desktop-only layout): never show the floating bar.
      triggerVisible = true;
      applyVisibility();
    }

    // Hide floating bar while modal is open; re-evaluate when it closes.
    var modalObserver = new MutationObserver(applyVisibility);
    modalObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });

    // Floating bar countdown timer
    var countdownEl = floatingBar.querySelector('[data-floating-countdown]');
    var countdownContainer = floatingBar.querySelector('.atc-floating-bar__countdown');
    if (countdownEl && countdownContainer) {
      var isInfinite = countdownContainer.dataset.infiniteLoop === 'true';
      var dateStr = countdownContainer.dataset.countdownDate;
      if (dateStr || isInfinite) {
        var targetDate = dateStr ? new Date(dateStr).getTime() : 0;
        function updateFloatingCountdown() {
          if (isInfinite) {
            renderInfiniteCountdown({ singleEl: countdownEl });
            return;
          }
          var now = new Date().getTime();
          var distance = targetDate - now;
          if (distance <= 0) {
            countdownContainer.style.display = 'none';
            return;
          }
          var d = Math.floor(distance / (1000 * 60 * 60 * 24));
          var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var s = Math.floor((distance % (1000 * 60)) / 1000);
          countdownEl.textContent = (d > 0 ? d + ' : ' : '') + String(h).padStart(2, '0') + ' : ' + String(m).padStart(2, '0') + ' : ' + String(s).padStart(2, '0');
        }
        updateFloatingCountdown();
        setInterval(updateFloatingCountdown, 1000);
      }
    }
  }

  // Desktop inline stock-info / delivery indicators next to the variant_picker block.
  // Hidden by default; revealed on the first variant change. Mirrors modal logic.
  document.querySelectorAll('[data-pdp-inline-indicators]').forEach(function (root) {
    var pickerRoot = root.previousElementSibling;
    while (pickerRoot && !pickerRoot.matches('variant-radios, variant-selects')) {
      pickerRoot = pickerRoot.previousElementSibling;
    }
    if (!pickerRoot) return;

    applyDeliveryDates(root);

    var stockInfo = root.querySelector('.atc-modal__stock-info');
    var stockText = stockInfo ? stockInfo.querySelector('[data-stock-text]') : null;
    var deliveryInfo = root.querySelector('.atc-modal__delivery .product-info-delivery');
    var fastEl = root.querySelector('.product-info-delivery__fast');
    var normalEl = root.querySelector('.product-info-delivery__normal');

    function updateStock(inventory, isOutOfStock) {
      if (!stockInfo || !stockText) return;
      if (isOutOfStock || inventory <= 0) {
        stockInfo.classList.add('hidden');
        return;
      }
      var translations = (window.theme && window.theme.translations) || {};
      if (inventory === 1) {
        stockText.textContent = translations.stock_info_last_unit || 'Last unit';
        stockInfo.classList.remove('hidden');
      } else if (inventory === 2) { // 2026-09: 3+ → nothing
        stockText.textContent = translations.stock_info_low || 'Low stock';
        stockInfo.classList.remove('hidden');
      } else {
        stockInfo.classList.add('hidden');
      }
    }

    function updateDelivery(isFastShipping, isOutOfStock) {
      if (!deliveryInfo) return;
      if (isOutOfStock) {
        deliveryInfo.style.display = 'none';
        return;
      }
      deliveryInfo.style.display = '';
      deliveryInfo.classList.toggle('fast-shipping', isFastShipping);
      deliveryInfo.classList.toggle('normal-shipping', !isFastShipping);
      if (isFastShipping) {
        if (fastEl) {
          fastEl.style.display = 'flex';
          fastEl.style.alignItems = 'center';
          fastEl.style.flexDirection = 'row';
          fastEl.style.justifyContent = 'center';
          fastEl.style.width = '100%';
        }
        if (normalEl) normalEl.style.display = 'none';
      } else {
        if (normalEl) {
          normalEl.style.display = 'flex';
          normalEl.style.alignItems = 'center';
          normalEl.style.flexDirection = 'row';
          normalEl.style.justifyContent = 'center';
          normalEl.style.width = '100%';
        }
        if (fastEl) fastEl.style.display = 'none';
      }
    }

    pickerRoot.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('variant-input')) return;
      root.classList.add('is-active');
      var inventory = parseInt(input.dataset.inventory, 10) || 0;
      var isOutOfStock = input.classList.contains('disabled');
      var isFastShipping = input.hasAttribute('variant-fast-ship-input');
      updateStock(inventory, isOutOfStock);
      updateDelivery(isFastShipping, isOutOfStock);
    });
  });
});
